import { createStyles } from "antd-style";

export const useStyles = createStyles(({ css, prefixCls }) => {
  return {
    // loading 无限循环
    toastContainer: css`
      .${prefixCls}-message-notice-content {
        background-color: var(--edgen-background_solid_primary) !important;
        border-radius: 12px !important;
        padding: 12px 16px 12px 12px !important;
        border: 1px solid var(--edgen-border_white_transparent10) !important;
        box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.08) !important;
    `,
    toastContainerAction: css`
      &.${prefixCls}-message-notice {
        align-self: flex-end !important;
        margin-inline: auto 16px !important;
        text-align: left !important;
      }
      .${prefixCls}-message-notice-content {
        background-color: var(--edgen-background_solid_neutral_primary) !important;
        border-radius: 8px !important;
        padding: 12px 16px 12px 12px !important;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08) !important;
        width: 100% !important;
        max-width: min(100vw - 32px, 360px) !important;
      }
      .${prefixCls}-message-custom-content {
        align-items: center !important;
        justify-content: flex-start !important;
        gap: 8px !important;
        width: 100% !important;
        text-align: left !important;
      }
    `,
  };
});
